/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { Grid, GridColumn, getSelectedState } from '@progress/kendo-react-grid';
import * as API from "../../framework/API/api"
import { ImageCell } from "../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { TOAST_TYPES } from "../../framework/constant/constant";
import { getter } from "@progress/kendo-data-query";
import { utility } from "../../framework/utility/utilityProvider";
import CustomPaginationDropDown from "../../framework/forms/helpercomponents/CustomGridCells/CustomPaginationDropDown";
import BossDialog from "../../components/BossDialog";
import ToastNotification from "../../components/ToastNotification";

const DATA_ITEM_KEY = "tmdbID";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const SeasonCollapseItem = ({ season, tmdbID, allowSingleSeasonSelect, onSelectSeason }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [episodes, setEpisodes] = useState([]);
    const [loading, setLoading] = useState(false);

    const toggleOpen = async () => {
        const nextState = !isOpen;
        setIsOpen(nextState);
        if (nextState && episodes.length === 0) {
            setLoading(true);
            const res = await API.getTMDBSeason(tmdbID, season.season_number);
            if (res.success) {
                setEpisodes(res.data ?? []);
            }
            setLoading(false);
        }
    };

    const handleSelectSeasonClick = async (e) => {
        e.stopPropagation();
        setLoading(true);
        let epList = episodes;
        if (epList.length === 0) {
            const res = await API.getTMDBSeason(tmdbID, season.season_number);
            if (res.success) {
                epList = res.data ?? [];
                setEpisodes(epList);
            }
        }
        setLoading(false);
        if (onSelectSeason) {
            onSelectSeason(season, epList);
        }
    };

    return (
        <div className="card mb-2" style={{ border: '1px solid #cbd5e1', borderRadius: '6px' }}>
            <div 
                className="card-header d-flex justify-content-between align-items-center" 
                style={{ backgroundColor: '#f8fafc', cursor: 'pointer', padding: '8px 12px' }} 
                onClick={toggleOpen}
            >
                <div className="d-flex align-items-center flex-grow-1 mr-2">
                    {season.poster_path ? (
                        <img 
                            src={season.poster_path} 
                            alt={season.name} 
                            style={{ width: '30px', height: '40px', marginRight: '10px', borderRadius: '4px', objectFit: 'cover' }} 
                        />
                    ) : (
                        <div style={{ width: '30px', height: '40px', marginRight: '10px', borderRadius: '4px', backgroundColor: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="fa fa-television text-muted" style={{ fontSize: '12px' }}></i>
                        </div>
                    )}
                    <div className="flex-grow-1">
                        <strong style={{ fontSize: '13px', color: '#1e293b' }}>{season.name}</strong>
                        <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                            <span>{season.episode_count} Episodes | Air Date: {season.air_date ?? 'N/A'}</span>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                    {allowSingleSeasonSelect && (
                        <button 
                            type="button" 
                            className="btn btn-xs btn-info py-0 px-2 text-white" 
                            style={{ fontSize: '11px', height: '22px', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}
                            onClick={handleSelectSeasonClick}
                        >
                            <i className="fa fa-plus-circle" /> Select
                        </button>
                    )}
                    <i className={`fa ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} style={{ color: '#94a3b8', fontSize: '12px' }} />
                </div>
            </div>
            {isOpen && (
                <div className="card-body" style={{ padding: '10px', maxHeight: '250px', overflowY: 'auto', backgroundColor: '#ffffff' }}>
                    {loading ? (
                        <div className="text-center py-3 text-muted" style={{ fontSize: '12px' }}>
                            <i className="fa fa-spinner fa-spin mr-2" /> Loading episodes...
                        </div>
                    ) : episodes.length === 0 ? (
                        <div className="text-center text-muted py-3" style={{ fontSize: '12px' }}>
                            No episodes found.
                        </div>
                    ) : (
                        <table className="table table-sm table-striped mb-0" style={{ fontSize: '12px' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '40px', borderBottom: '1px solid #e2e8f0' }}>#</th>
                                    <th style={{ borderBottom: '1px solid #e2e8f0' }}>Title</th>
                                    <th style={{ width: '90px', borderBottom: '1px solid #e2e8f0' }}>Air Date</th>
                                    <th style={{ width: '70px', borderBottom: '1px solid #e2e8f0' }}>Runtime</th>
                                </tr>
                            </thead>
                            <tbody>
                                {episodes.map(ep => (
                                    <tr key={ep.id}>
                                        <td className="align-middle text-muted">{ep.episode_number}</td>
                                        <td className="align-middle">
                                            <div style={{ fontWeight: '600', color: '#334155' }}>{ep.name}</div>
                                            {ep.overview && <div className="text-muted" style={{ fontSize: '11px', marginTop: '2px', lineHeight: '1.3' }}>{ep.overview}</div>}
                                        </td>
                                        <td className="align-middle text-muted">{ep.air_date ?? 'N/A'}</td>
                                        <td className="align-middle text-muted">{ep.runtime} min</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
        </div>
    );
};

const TMDBEditForm = (props) => {
    const lang = useTranslation();

    const blankDataItem = {
        SearchName: ""
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [gridData, setGridData] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const [selectedItemDetails, setSelectedItemDetails] = useState({});
    const initialDataState = {
        skip: 0,
        take: 10,
    };
    const [page, setPage] = useState(initialDataState);
    const [total, setTotal] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Loading...");

    const allowSingleSeasonSelect = props.allowSingleSeasonSelect ?? false;

    const onSearch = async () => {
        if (!dataItem.SearchName || dataItem.SearchName.trim() === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_search_name_error_message || "Please enter a search name" });
            return;
        }

        setLoadingMessage("Searching TV shows...");
        setLoading(true);

        let payload = {
            SearchName: dataItem.SearchName.trim() ?? "",
            Page: 1
        };

        let res = await API.getTMDBData(payload);
        if (res.success) {
            setPage(initialDataState);
            setGridData(res.data);
            setTotal(res.pagination?.total);
            setSelectedState({});
            setSelectedItemDetails({});
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setLoading(false);
    };

    const onSelectionChange = useCallback(
        async (event) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            });
            let tmdbID = gridData.find((item) => newSelectedState[item.tmdbID])?.tmdbID;
            if (tmdbID) {
                setLoadingMessage("Fetching TV series details...");
                setLoading(true);
                let res = await API.getTMDBDetails(tmdbID);
                if (res.success) {
                    setSelectedItemDetails(res.data);
                }
                setLoading(false);
            }
            setSelectedState(newSelectedState);
        },
        [selectedState, gridData]
    );

    const pageChange = async (e) => {
        let payload = {
            SearchName: dataItem.SearchName ?? "",
            Page: (e.page.skip / e.page.take) + 1,
        };
        setLoadingMessage("Loading next page...");
        setLoading(true);
        let res = await API.getTMDBData(payload);
        if (res.success) {
            setGridData(res.data);
            setSelectedState({});
            setSelectedItemDetails({});
            setPage(e.page);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setLoading(false);
    };

    const handleSubmit = async () => {
        if (gridData.filter((item) => selectedState[idGetter(item)]).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_item_first_error_message || "Please select an item first" });
            return;
        }

        let seasons = selectedItemDetails.Seasons ?? [];
        let updatedSeasons = [...seasons];

        setLoadingMessage("Fetching all season episodes... Please wait");
        setLoading(true);

        try {
            const promises = seasons.map(async (season, index) => {
                const res = await API.getTMDBSeason(selectedItemDetails.tmdbID, season.season_number);
                if (res.success) {
                    updatedSeasons[index] = {
                        ...season,
                        EpisodesList: res.data ?? []
                    };
                }
            });

            await Promise.all(promises);

            const finalDetails = {
                ...selectedItemDetails,
                Seasons: updatedSeasons
            };

            props.tmdbDataList(finalDetails);
            props.cancelEdit();
        } catch (e) {
            console.error("Failed fetching all seasons episodes", e);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: "Error", message: "Failed to fetch all episodes" });
            props.tmdbDataList(selectedItemDetails);
            props.cancelEdit();
        } finally {
            setLoading(false);
        }
    };

    const handleSelectSeason = (season, episodesList) => {
        if (props.onSelectSeason) {
            props.onSelectSeason(selectedItemDetails, season, episodesList);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            onSearch();
        }
    };

    return (
        <BossDialog
            title={"TMDB TV Series Details"}
            onClose={props.cancelEdit}
            width={"80%"}
        >
            <div style={{ position: 'relative' }}>
                {loading && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.75)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        minHeight: '400px',
                        borderRadius: '6px'
                    }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: '40px', color: '#01b4e4' }} />
                        <span className="mt-3" style={{ fontWeight: 600, color: '#334155', fontSize: '14px' }}>{loadingMessage}</span>
                    </div>
                )}
                
                <EditPageHeader showTitle={false} showSaveButton={!allowSingleSeasonSelect} onSubmit={handleSubmit} onCancel={props.cancelEdit} />
                <div className="row">
                    <div className="col-12">
                        <div className="row mt-2 align-items-end">
                            <div className="col-8">
                                <label>{lang.search_name_label || "Search Name"} *</label>
                                <div className="d-flex">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm shadow-inset-2"
                                        id="searchInput"
                                        name="SearchName"
                                        value={dataItem.SearchName}
                                        onChange={(e) => setDataItem({ ...dataItem, SearchName: e.target.value })}
                                        onKeyDown={handleKeyDown}
                                        placeholder={lang.search_name_label || "Search TV show..."}
                                        onFocus={(e) => {
                                            if (props.setOutSideFocus) {
                                                props.setOutSideFocus(true);
                                            }
                                        }}
                                        onBlur={(e) => {
                                            if (props.setOutSideFocus) {
                                                props.setOutSideFocus(false);
                                            }
                                        }}
                                    />
                                    <button id="search" style={{ border: "0px", backgroundColor: "white", height: "30px" }} onClick={onSearch}>
                                        <div className="input-group-append" style={{ height: '32px' }}>
                                            <span className="input-group-text">
                                                <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                            </span>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <div className="col-4">
                                <ActionButton name={lang.search_button_text || "Search"} title={lang.search_button_tooltip || "Search"} onClick={onSearch} />
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className={(gridData?.filter((item) => selectedState[idGetter(item)]).length !== 0) ? "col-5" : "col-12"}>
                                <Grid
                                    data={gridData.map((item) => ({
                                        ...item,
                                        [SELECTED_FIELD]: selectedState[idGetter(item)],
                                    }))}
                                    dataItemKey={DATA_ITEM_KEY}
                                    selectedField={SELECTED_FIELD}
                                    selectable={{
                                        enabled: true,
                                        drag: false,
                                        cell: false,
                                        mode: "single",
                                    }}
                                    pageable={true}
                                    skip={page.skip}
                                    take={page.take}
                                    total={total}
                                    onPageChange={pageChange}
                                    onSelectionChange={onSelectionChange}
                                    resizable={true}
                                    style={{ height: "550px" }}
                                    pager={(props) => <CustomPaginationDropDown {...props} />}
                                >
                                    <GridColumn field="Poster" title={lang.poster_column || "Poster"} width={80} cell={ImageCell} />
                                    <GridColumn field="Title" title={lang.title_column || "Title"} />
                                    <GridColumn field="Year" title={lang.year_column || "Year"} width={90} />
                                    <GridColumn field="tmdbID" title={"TMDB ID"} width={100} />
                                </Grid>
                            </div>

                            {(gridData.filter((item) => selectedState[idGetter(item)]).length !== 0) && (
                                <div className="col-7 border" style={{ height: "550px", overflowY: 'scroll', maxWidth: "58%", padding: '15px', backgroundColor: '#fafafa', borderRadius: '6px' }}>
                                    <i className="fa fa-times-circle float-right mt-1" style={{ fontSize: '25px', cursor: 'pointer', color: '#ef4444' }} onClick={() => { setSelectedState({}); setSelectedItemDetails({}) }} />
                                    
                                    <div className="row mt-2">
                                        <div className="col-7">
                                            <div className="row">
                                                <div className="col-12 mt-1">
                                                    <h3 style={{ margin: 0, fontWeight: 'bold', color: '#0f172a' }}>
                                                        {selectedItemDetails?.Title}
                                                    </h3>
                                                </div>
                                                <div className="col-12 mt-2" style={{ fontSize: '13px' }}>
                                                    <span className="badge badge-pill badge-primary mr-2" style={{ backgroundColor: '#3b82f6' }}>
                                                        Rating: {selectedItemDetails?.VoteAverage ? selectedItemDetails.VoteAverage.toFixed(1) : 'N/A'} / 10
                                                    </span>
                                                    <span className="text-muted">
                                                        <i className="fa fa-calendar mr-1" /> {selectedItemDetails?.Year} ({selectedItemDetails?.Status})
                                                    </span>
                                                </div>
                                                <div className="col-12 mt-3" style={{ fontSize: '13px' }}>
                                                    <strong>Genres:</strong> <span className="ml-1 text-muted">{selectedItemDetails?.Genres || 'N/A'}</span>
                                                </div>
                                                <div className="col-12 mt-2" style={{ fontSize: '13px' }}>
                                                    <strong>Languages:</strong> <span className="ml-1 text-muted">{selectedItemDetails?.Language || 'N/A'}</span>
                                                </div>
                                                <div className="col-12 mt-2" style={{ fontSize: '13px' }}>
                                                    <strong>Seasons:</strong> <span className="ml-1 text-muted">{selectedItemDetails?.SeasonsCount} Seasons</span>
                                                </div>
                                                <div className="col-12 mt-2" style={{ fontSize: '13px' }}>
                                                    <strong>Episodes:</strong> <span className="ml-1 text-muted">{selectedItemDetails?.EpisodesCount} Episodes</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-5 text-center">
                                            <img 
                                                style={{ borderRadius: "8px", boxShadow: "0px 4px 12px rgba(0,0,0,0.15)", maxWidth: "100%", height: "200px", objectFit: 'cover' }} 
                                                src={selectedItemDetails?.Poster ? selectedItemDetails.Poster : "https://res.cloudinary.com/dl2n34gbw/image/upload/v1714465970/wymufa5fvzqe16x8st6l.png"} 
                                                alt={selectedItemDetails?.Title} 
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <h5 style={{ fontWeight: 'bold', color: '#1e293b' }}>{lang.synopsis_label || "Synopsis"}</h5>
                                            <p style={{ fontSize: '13px', color: '#475569', lineHeight: '1.5' }}>{selectedItemDetails?.Overview || 'No description available.'}</p>
                                        </div>
                                    </div>

                                    <hr style={{ margin: '15px 0' }} />

                                    <div className="row mt-2">
                                        <div className="col-12">
                                            <h5 style={{ fontWeight: 'bold', color: '#1e293b', marginBottom: '12px' }}>Seasons & Episodes</h5>
                                            <div>
                                                {(selectedItemDetails?.Seasons ?? []).map(season => (
                                                    <SeasonCollapseItem 
                                                        key={season.season_number} 
                                                        season={season} 
                                                        tmdbID={selectedItemDetails.tmdbID} 
                                                        allowSingleSeasonSelect={allowSingleSeasonSelect}
                                                        onSelectSeason={handleSelectSeason}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </BossDialog >
    )
}

export default TMDBEditForm;
